import Icon from '../components/Icon.vue'

Icon.register({
  'map-signs': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M507.3 84.7c6.3 6.3 6.3 16.4 0 22.6l-43.3 43.3c-6 6-14.1 9.4-22.6 9.4h-385.4c-13.3 0-24-10.8-24-24v-80c0-13.3 10.8-24 24-24h168v-16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v16h153.4c8.5 0 16.6 3.4 22.6 9.4zM224 496v-112h64v112c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zM456 224c13.3 0 24 10.8 24 24v80c0 13.3-10.8 24-24 24h-385.4c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3c-6.3-6.3-6.3-16.4 0-22.6l43.3-43.3c6-6 14.1-9.4 22.6-9.4h153.4v-32h64v32h168z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/map-signs.js
// module id = 1545
// module chunks = 0